import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LangContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { apiError } from "@/lib/api";
import { LOGO_URL } from "@/lib/constants";
import { toast } from "sonner";

export default function Login() {
  const { t } = useLang();
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await login(email, pw); toast.success("مرحباً 👋"); nav("/"); }
    catch (err) { toast.error(apiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-14">
      <div className="text-center mb-8">
        <img src={LOGO_URL} alt="FLUORIT" className="mx-auto h-16 w-16 object-contain" />
        <h1 className="text-2xl font-extrabold text-emerald-950 mt-3">{t.auth.loginTitle}</h1>
      </div>
      <form onSubmit={submit} className="bg-white border border-slate-200 rounded-2xl p-6 space-y-4">
        <div><Label>{t.auth.email}</Label>
          <Input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div><Label>{t.auth.password}</Label>
          <Input data-testid="login-password" type="password" required value={pw} onChange={(e) => setPw(e.target.value)} />
        </div>
        <Button data-testid="login-submit" disabled={loading} className="w-full h-11 bg-emerald-950 hover:bg-emerald-900">{loading ? "…" : t.auth.loginBtn}</Button>
        <div className="text-sm text-center text-slate-600">
          {t.auth.switchToReg} <Link to="/register" className="text-emerald-900 font-semibold">{t.nav.register}</Link>
        </div>
      </form>
    </div>
  );
}
